var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OrderItem } from 'aigens-ng-core';
import { MobileBasePage } from '../../../core/base/mobile-base-page';
import { Injector, OnInit } from '@angular/core';
import { IonSlide, Events } from '@ionic/angular';
import { TransactionsConfirm } from '../../../dialogs/transactions-confirm/transactions-confirm.component';
import { getDateStringLabel, timeStringLabel } from '../../../shared/utilities/checkFormatTool';
var SummaryListPage = /** @class */ (function (_super) {
    __extends(SummaryListPage, _super);
    function SummaryListPage(injector, events) {
        var _this = _super.call(this, injector) || this;
        _this.events = events;
        _this.currentOrders = [];
        _this.completedOrders = [];
        _this.listExpand = {};
        _this.partial = true;
        _this.limitFrom = 0;
        _this.limitTo = 10;
        _this.limitToExtra = 11;
        _this.savedOrders = {};
        _this.canGoNextPage = false;
        _this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + _this.currentTimeString();
        _this.session = _this.getNavParams('sessionId');
        if (!_this.session) {
            _this.session = _this.orderService.session;
        }
        return _this;
    }
    SummaryListPage.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (!this.orders) {
            this.getOrders();
        }
    };
    SummaryListPage.prototype.handlingCacheOrders = function (limitFrom) {
        this.orders = this.savedOrders[this.limitFrom];
        this.resetOrderGrouping();
        this.groupingOrder(this.savedOrders[this.limitFrom]);
        this.canGoNextPage = this.savedOrders[this.limitFrom]['haveNextPage'];
    };
    // check if orders.length >= 10
    SummaryListPage.prototype.nextPageClicked = function () {
        this.limitFrom += 10;
        this.limitTo += 10;
        this.limitToExtra += 10;
        if (this.savedOrders[this.limitFrom]) {
            // orders are previously saved
            this.handlingCacheOrders(this.limitFrom);
        }
        else {
            this.getOrders();
        }
    };
    // check if limitto === 0
    SummaryListPage.prototype.previousPageClicked = function () {
        this.limitFrom -= 10;
        this.limitTo -= 10;
        this.limitToExtra -= 10;
        this.handlingCacheOrders(this.limitFrom);
    };
    SummaryListPage.prototype.getOrders = function (refresher) {
        var _this = this;
        // limitTo:number = 10,limitFrom:number = 0
        this.loading(true);
        var today = new Date().getTime();
        var since = new Date().getTime();
        since = today - 31556952000;
        console.log('since time', since);
        // var limitFrom: number = 0;
        // var limitTo: number = 10;
        this.orderService.getOrders(this.session, this.partial, this.limitToExtra, this.limitFrom, since).subscribe(function (orders) {
            if (refresher) {
                refresher.complete();
            }
            _this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + _this.currentTimeString();
            _this.orders = orders;
            console.log('getorder', orders);
            if (_this.orders && _this.orders.length > 0) {
                _this.orders.forEach(function (order) {
                    if (order.orderitems) {
                        order.orderitems.forEach(function (oi) {
                            // oi.makeFlatItems();
                            OrderItem.flattenItems(oi);
                        });
                    }
                    if (order.pickup) {
                        order['pickupTimeLabel'] = timeStringLabel(order.pickup);
                    }
                });
            }
            _this.resetOrderGrouping();
            _this.groupingOrder(orders.slice(0, 10));
            // savedOrders only if savedOrders is null
            if (!_this.savedOrders[_this.limitFrom]) {
                _this.savedOrders[_this.limitFrom] = orders.slice(0, 10);
                if (orders.length > 10) {
                    _this.savedOrders[_this.limitFrom]['haveNextPage'] = true;
                    _this.canGoNextPage = _this.savedOrders[_this.limitFrom]['haveNextPage'];
                }
                else {
                    _this.savedOrders[_this.limitFrom]['haveNextPage'] = false;
                    _this.canGoNextPage = _this.savedOrders[_this.limitFrom]['haveNextPage'];
                }
            }
            _this.loading(false);
        }, function (err) {
            _this.loading(false);
            if (refresher) {
                refresher.complete();
            }
            else {
                _this.showError(err);
            }
            _this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + _this.currentTimeString();
            console.log(err);
        }, function () {
            _this.loading(false);
        });
    };
    SummaryListPage.prototype.pickupHandler = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: TransactionsConfirm, componentProps: {
                                order: order, handler: function () {
                                    // call api here
                                    _this.orderService.orderChangeStatus('completed', order.id).subscribe(function (tmpOrder) {
                                        modal.dismiss();
                                        _this.getOrders();
                                        tmpOrder.orderitems = order.orderitems;
                                        tmpOrder.store = order.store;
                                        _this.orderClicked(tmpOrder);
                                    }, function (err) {
                                        _this.showError(err);
                                        modal.dismiss();
                                        console.log(err);
                                    });
                                }
                            }
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryListPage.prototype.showAllOrder = function () {
        this.partial = false;
        this.loading(true);
        this.getOrders();
    };
    SummaryListPage.prototype.orderClicked = function (order) {
        var _this = this;
        console.log("TCL: SummaryListPage -> orderClicked -> order", order);
        this.pushByName('MultiOrderDetailPage', { orderDetail: order }).then(function () {
            console.log("MultiOrderDetailPage done");
            _this.events.publish('pushToOrderDetail', { orderDetail: order });
        });
    };
    SummaryListPage.prototype.doRefresh = function (refresher) {
        this.getOrders(refresher);
    };
    SummaryListPage.prototype.onRefreshUI = function () {
        console.log('refresh ui');
        this.doRefresh();
    };
    SummaryListPage.prototype.currentTimeString = function () {
        return timeStringLabel(null, true);
    };
    SummaryListPage.prototype.resetOrderGrouping = function () {
        this.currentOrders = [];
        this.completedOrders = [];
    };
    SummaryListPage.prototype.groupingOrder = function (orders) {
        var _this = this;
        orders.forEach(function (order) {
            if (order.status === 'ready') {
                _this.currentOrders.push(order);
            }
            else if (order.status === 'received') {
                _this.currentOrders.push(order);
            }
            else if (order.status === 'paid') {
                _this.currentOrders.push(order);
            }
            else if (order.status === 'completed') {
                _this.completedOrders.push(order);
            }
            else if (order.status === 'pending') {
                _this.currentOrders.push(order);
                // tmp
                _this.completedOrders.push(order);
            }
            else if (order.status === 'cancelled') {
                _this.completedOrders.push(order);
            }
            else if (order.status === 'failed') {
                _this.completedOrders.push(order);
            }
        });
    };
    SummaryListPage.prototype.isSet = function (oi) {
        return OrderItem.isSet(oi);
    };
    SummaryListPage.prototype.pageName = function () {
        return '/summary-list';
    };
    return SummaryListPage;
}(MobileBasePage));
export { SummaryListPage };
